import { ClientResponse } from '@commercetools/platform-sdk';
import sortBy from 'lodash/sortBy';

import { ctApi } from '@/api';
import {
  CustomProductProjectionSearch,
  CustomProductProjectionSearchResponse,
  DetailProductsByCustomProductKey,
  DetailProductsByCustomProductKeyProjectionResult,
  DetailProductsByCustomProductKeyProjectionSearchResponse,
  DetailProductsByCustomProductKeyVariables,
  SearchByCustomProductKeyVariables,
} from '@/graphql/customProducts';
import {
  NutsProductProjection,
  NutsProductProjectionDisplayVariant,
} from '@/utils/productProjection';
import { reportError } from '@/utils/reportError';

export async function fetchGreetingCards(): Promise<NutsProductProjectionDisplayVariant[]> {
  const response = (await ctApi
    .graphql()
    .post({
      body: {
        query: CustomProductProjectionSearch,
        variables: {
          customProductKey: ['Greeting Card'],
        } satisfies SearchByCustomProductKeyVariables,
      },
    })
    .execute()) as unknown as ClientResponse<CustomProductProjectionSearchResponse>;

  const { results } = response.body.data.productProjectionSearch;

  const greetingCards: NutsProductProjectionDisplayVariant[] = [];
  results.forEach((result) => {
    try {
      const productProjection = NutsProductProjection.fromQueryResult(result);
      greetingCards.push(NutsProductProjection.toDisplayVariant(productProjection));
    } catch (error) {
      reportError(error);
    }
  });

  return sortBy(greetingCards, 'orderHint');
}

export async function fetchCustomProductDetail(
  variables: DetailProductsByCustomProductKeyVariables,
): Promise<DetailProductsByCustomProductKeyProjectionResult[]> {
  const response = (await ctApi
    .graphql()
    .post({
      body: {
        query: DetailProductsByCustomProductKey,
        variables,
      },
    })
    .execute()) as unknown as ClientResponse<DetailProductsByCustomProductKeyProjectionSearchResponse>;

  const { results } = response.body.data.productProjectionSearch;

  return results;
}
